import { defineStore } from 'pinia'

const useAuthStore = defineStore('auth', {
  state: () => ({
    accessTokenFlow: null,
  }),

  getters: {
    isLoggedIn: state => !!state.accessTokenFlow,
    possuiTokenFlowDefinido: state => !!state.accessTokenFlow,
  },

  actions: {
    setAccessTokenFlow(token) {
      this.accessTokenFlow = token
    },
    clear() {
      this.accessTokenFlow = null
    },
  },

  persist: true,
})

export default useAuthStore
